import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit/src'
import {UpmPlantProvider} from '@hconnect/upm'
import {usePlantUpmIdFromHierarchyId} from '@hproduce/suite-core'
import {ThemeProvider} from '@mui/material'
import {Navigate, RouteObject} from 'react-router'

import {RouteSegment} from '../consts'
import {productionPlanningFeatureTranslations} from '../localization'
import {
  PageProductionPlanning,
  PageDailyProductionPlanning,
  PageMonthlyProductionPlanning
} from '../pages'

const SuiteProductionPlanningPage = () => {
  const plantUpmId = usePlantUpmIdFromHierarchyId()

  return (
    <UpmPlantProvider plantUpmId={plantUpmId}>
      <PageProductionPlanning />
    </UpmPlantProvider>
  )
}

const SuiteProductionPlanningRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={productionPlanningFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <SuiteProductionPlanningPage />
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const productionPlanningRoutes: RouteObject = {
  path: '*',
  element: <SuiteProductionPlanningRouteWrapper />,
  children: [
    {index: true, element: <Navigate to={RouteSegment.DAILY} replace />},
    {path: RouteSegment.DAILY, element: <PageDailyProductionPlanning />},
    {path: RouteSegment.MONTHLY, element: <PageMonthlyProductionPlanning />}
  ]
}
